export const reservationTypeOptions = [
  {
    value: 'all',
    label:
      'pageScreenAndProtect.detailsPage.sections.protectionDetails.reservationType.all',
  },
  {
    value: 'new',
    label:
      'pageScreenAndProtect.detailsPage.sections.protectionDetails.reservationType.new',
  },
] as const;
